import { toast } from "@/hooks/useToast"

export const showSuccess = (msg: string) =>
  toast({
    title: "Success",
    description: msg,
    className: "bg-green-600 text-white",
  })

export const showError = (msg: string) =>
  toast({
    title: "Error",
    description: msg,
    variant: "destructive",
  })